import script from "./bannerMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./bannerMobile.vue?vue&type=script&setup=true&lang=js"

import "./bannerMobile.vue?vue&type=style&index=0&id=2c2c7d68&lang=less"

const __exports__ = script;

export default __exports__